<div class="modal-overlay" (click)="onCloseModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <!-- Close Button -->
        <button class="close-btn" (click)="onCloseModal()" aria-label="Close modal">
            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
        </button>

        <!-- Modal Content -->
        <div class="modal-body">
            <!-- Error Message -->
            <div class="error-message">
                <h2>{{ t('accountNotFoundTitle') }}</h2>
                <p>{{ t('accountNotFoundMessage') }}</p>
            </div>

            <!-- Vector Image -->
            <div class="vector-image">
                <img src="/svg/userNotFound.svg" alt="User not found illustration" />
            </div>

            <!-- Registration Button -->
            <div class="action-buttons">
                <button class="register-btn" routerLink="/register" (click)="onRegisterClick()">
                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                    </svg>
                    {{ t('createNewAccount') }}
                </button>

                <button class="cancel-btn" (click)="onCloseModal()">
                    {{ t('close') }}
                </button>
            </div>
        </div>
    </div>
</div>